"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");

var _Array$from = require("@babel/runtime-corejs3/core-js-stable/array/from");

var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");

var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");

var _Array$isArray2 = require("@babel/runtime-corejs3/core-js-stable/array/is-array");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.tagSelectValueRenderer = exports.showMaxFilterValues = exports.renderWithMoreFilterCount = exports.renderTagSelectValue = exports.renderRow = exports.renderFilter = exports.popoverDataParser = exports.makeFieldNameToGroupMap = exports.isTagSelectValue = exports.isFieldInTooltipGroups = exports.getValueOfAppliedField = exports.getTooltipGroupAppliedCount = exports.getAppliedFiltersCount = exports.createGroupedTooltip = exports.createGroupFieldValuesObject = exports.combineFilters = exports.ToolTipWrapper = exports.RenderToolTip = exports.ButtonWrapper = void 0;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _isString = _interopRequireDefault(require("lodash-es/isString"));

var _isArray2 = _interopRequireDefault(require("lodash-es/isArray"));

var _get = _interopRequireDefault(require("lodash-es/get"));

var _map2 = _interopRequireDefault(require("lodash-es/map"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cloneDeep = _interopRequireDefault(require("lodash-es/cloneDeep"));

var _find = _interopRequireDefault(require("lodash-es/find"));

var _take = _interopRequireDefault(require("lodash-es/take"));

var _utils = require("./utils");

var _tooltip = _interopRequireDefault(require("../tooltip/tooltip"));

var _icon = _interopRequireDefault(require("../icon/icon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (_Array$isArray2(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context9; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context7, _context8; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty2(_context7 = ownKeys(Object(source), !0)).call(_context7, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty2(_context8 = ownKeys(Object(source))).call(_context8, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var showMaxFilterValues = 3;
exports.showMaxFilterValues = showMaxFilterValues;

var ButtonWrapper = function ButtonWrapper(_ref) {
  var _context, _context2;

  var appliedFilters = _ref.appliedFilters,
      onButtonMouseDown = _ref.onButtonMouseDown,
      tooltipGroups = _ref.tooltipGroups,
      className = _ref.className,
      ariaLabel = _ref.ariaLabel,
      dataTestId = _ref.dataTestId,
      buttonRef = _ref.buttonRef;
  var prevValue = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      filterCountChange = _useState2[0],
      setFilterCountChange = _useState2[1];

  var appliedFiltersCount = getAppliedFiltersCount(appliedFilters, tooltipGroups);
  (0, _react.useEffect)(function () {
    if (prevValue.current !== appliedFiltersCount) {
      prevValue.current = appliedFiltersCount;
      setFilterCountChange(true);
    }

    var timer = (0, _setTimeout2["default"])(function () {
      if (filterCountChange) {
        setFilterCountChange(false);
      }
    }, 1000);
    return function () {
      return clearTimeout(timer);
    };
  }, [appliedFiltersCount, filterCountChange]);
  return /*#__PURE__*/_react["default"].createElement("button", {
    "data-testid": dataTestId,
    filtercount: appliedFiltersCount,
    onMouseDown: onButtonMouseDown,
    "aria-label": ariaLabel,
    className: (0, _concat["default"])(_context = (0, _concat["default"])(_context2 = "oui-btn oui-btn-md oui-btn-outline-primary oui-filter-button-trigger ".concat(!!appliedFiltersCount && "oui-filters-applied" || "", " ")).call(_context2, className || "", " ")).call(_context, filterCountChange ? "oui-filter-count-anim" : ""),
    ref: buttonRef
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "icon",
    svg: /*#__PURE__*/_react["default"].createElement("svg", {
      id: "filter-button-svg",
      className: "filter-button-svg",
      "data-name": "Layer 2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 29"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M670-94h28a2,2,0,0,0,2-2,2,2,0,0,0-2-2H670a2,2,0,0,0-2,2A2,2,0,0,0,670-94Z",
      transform: "translate(-668 98)"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M694-86H674a2,2,0,0,0-2,2,2,2,0,0,0,2,2h20a2,2,0,0,0,2-2A2,2,0,0,0,694-86Z",
      transform: "translate(-668 98)"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M690-74H678a2,2,0,0,0-2,2,2,2,0,0,0,2,2h12a2,2,0,0,0,2-2A2,2,0,0,0,690-74Z",
      transform: "translate(-668 98)"
    }))
  }));
};

exports.ButtonWrapper = ButtonWrapper;

var RenderToolTip = function RenderToolTip(_ref2) {
  var appliedFilters = _ref2.appliedFilters,
      tooltipGroups = _ref2.tooltipGroups;
  var tooltip;

  if (tooltipGroups) {
    tooltip = createGroupedTooltip(appliedFilters, tooltipGroups);
  } else {
    tooltip = (0, _map2["default"])(appliedFilters, function (_ref3, key) {
      var title = _ref3.title,
          value = _ref3.value,
          _ref3$valueRenderer = _ref3.valueRenderer,
          valueRenderer = _ref3$valueRenderer === void 0 ? null : _ref3$valueRenderer;

      if (!(0, _utils.isEmpty)(value) && title) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-filter",
          key: key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-filter-title",
          key: title
        }, title), renderFilter(value, valueRenderer));
      } else {
        return "";
      }
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-filter-tooltip"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-tool-tip-title",
    key: "key-tool-tip-title"
  }, " ", "Filters Applied"), tooltip);
};

exports.RenderToolTip = RenderToolTip;
RenderToolTip.defaultProps = {
  appliedFilters: []
};
RenderToolTip.propTypes = {
  appliedFilters: _propTypes["default"].array
}; // render single value

var renderRow = function renderRow(value, key) {
  var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "oui-filter-value";
  var valueRenderer = arguments.length > 3 ? arguments[3] : undefined;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className),
    key: key
  }, (0, _utils.isFunction)(valueRenderer) ? valueRenderer(value || "") : String(value));
};

exports.renderRow = renderRow;

var renderWithMoreFilterCount = function renderWithMoreFilterCount(filters, text, key, showMaxFilterValues, renderer) {
  if (filters.length > showMaxFilterValues && key === showMaxFilterValues - 1) {
    var _context3;

    var moreFilterCount = filters.length - showMaxFilterValues;
    var moreFilterText = "+".concat(moreFilterCount);
    return renderRow((0, _concat["default"])(_context3 = "".concat(text, "  ")).call(_context3, moreFilterText), key, "", renderer);
  } else {
    return renderRow(text, key, "", renderer);
  }
};

exports.renderWithMoreFilterCount = renderWithMoreFilterCount;

var isTagSelectValue = function isTagSelectValue(value) {
  if (!(0, _isArray2["default"])(value)) {
    return false;
  }

  return (0, _some["default"])(value).call(value, function (item) {
    return (0, _utils.hasProperty)(item, "key") && (0, _utils.hasProperty)(item.key, "label") && (0, _utils.hasProperty)(item, "value") && (0, _utils.hasProperty)(item.value, "label") || (0, _keys["default"])(item).length === 1 && (0, _utils.hasProperty)(item, "value");
  });
};

exports.isTagSelectValue = isTagSelectValue;

var tagSelectValueRenderer = function tagSelectValueRenderer(item, key, renderer, moreFilterText) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-filter-value",
    key: key
  }, (0, _utils.isFunction)(renderer) ? renderer(item) : !item.key && item.value ? item.value : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item.key.label, ": ", item.value.label), moreFilterText ? " ".concat(moreFilterText) : null);
};

exports.tagSelectValueRenderer = tagSelectValueRenderer;

var renderTagSelectValue = function renderTagSelectValue(filters, item, key, showMaxFilterValues, renderer) {
  if (filters.length > showMaxFilterValues && key === showMaxFilterValues - 1) {
    var moreFilterCount = filters.length - showMaxFilterValues;
    var moreFilterText = "+".concat(moreFilterCount);
    return tagSelectValueRenderer(item, key, renderer, moreFilterText);
  } else {
    return tagSelectValueRenderer(item, key, renderer);
  }
}; // Identify filter value type and render


exports.renderTagSelectValue = renderTagSelectValue;

var renderFilter = function renderFilter() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var valueRenderer = arguments.length > 1 ? arguments[1] : undefined;
  var renderer = (0, _utils.isFunction)(valueRenderer) ? valueRenderer : function (v) {
    return (0, _isString["default"])(v) ? v : String(v);
  };

  if (isTagSelectValue(value)) {
    return (0, _map2["default"])((0, _take["default"])(value, showMaxFilterValues), function (valueObject, key) {
      return renderTagSelectValue(value, valueObject, key, showMaxFilterValues, valueRenderer);
    });
  } else if (!(0, _utils.isEmpty)(value) && (0, _isArray2["default"])(value) && (0, _utils.isObject)(value[0]) && value[0].label) {
    // Render array of objects
    return (0, _map2["default"])((0, _take["default"])(value, showMaxFilterValues), function (valueObject, key) {
      return renderWithMoreFilterCount(value, valueObject.label, key, showMaxFilterValues, renderer);
    });
  } else if (!(0, _utils.isEmpty)(value) && (0, _isArray2["default"])(value) && (0, _isString["default"])(value[0])) {
    // Render array of strings
    return (0, _map2["default"])((0, _take["default"])(value, showMaxFilterValues), function (valueString, key) {
      return renderWithMoreFilterCount(value, valueString, key, showMaxFilterValues, renderer);
    });
  } else if ((0, _utils.isObject)(value) && value.label) {
    // Render single object
    return renderRow(value.label, "objectKey", "", renderer);
  }

  return renderRow(value, "value", "", renderer);
};

exports.renderFilter = renderFilter;

var combineFilters = function combineFilters() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$appliedFilters = _ref4.appliedFilters,
      appliedFilters = _ref4$appliedFilters === void 0 ? [] : _ref4$appliedFilters,
      _ref4$filters = _ref4.filters,
      filters = _ref4$filters === void 0 ? [] : _ref4$filters;

  var state = arguments.length > 1 ? arguments[1] : undefined;
  var oldFilters = (0, _cloneDeep["default"])((0, _get["default"])(state, "appliedFilters", []));
  var newFilters = [];
  (0, _forEach["default"])(filters).call(filters, function (element) {
    var fieldName = element.fieldName; // check if filter already present in state.appliedFilter

    var item = (0, _find["default"])(oldFilters, {
      fieldName: fieldName
    }); // filter is not preset

    if ((0, _utils.isEmpty)(item)) {
      // filter has applied value
      var appliedFilterItem = (0, _find["default"])(appliedFilters, {
        fieldName: fieldName
      });
      (0, _utils.isEmpty)(appliedFilterItem) ? newFilters.push(element) : newFilters.push(_objectSpread(_objectSpread({}, element), {}, {
        value: appliedFilterItem.value
      }));
    } else {
      // if filter is present
      var oldFilterItem = (0, _find["default"])(oldFilters, {
        fieldName: fieldName
      });
      newFilters.push(oldFilterItem);
    }
  });
  return newFilters;
};
/* convert object 
    FROM : [{ fieldName: 'userName', value: 'someValue' }]
    TO   : { userName: 'someValue' } */


exports.combineFilters = combineFilters;

var popoverDataParser = function popoverDataParser(appliedFilters) {
  var obj = {};
  (0, _forEach["default"])(appliedFilters).call(appliedFilters, function (filter) {
    obj[filter.fieldName] = (0, _get["default"])(filter, "value", "");
  });
  return obj;
};

exports.popoverDataParser = popoverDataParser;

var getAppliedFiltersCount = function getAppliedFiltersCount() {
  var appliedFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tooltipGroups = arguments.length > 1 ? arguments[1] : undefined;

  if (tooltipGroups) {
    return getTooltipGroupAppliedCount(appliedFilters, tooltipGroups);
  }

  return (0, _filter["default"])(appliedFilters).call(appliedFilters, function (_ref5) {
    var value = _ref5.value;
    return !(0, _utils.isEmpty)(value);
  }).length;
};

exports.getAppliedFiltersCount = getAppliedFiltersCount;

var ToolTipWrapper = function ToolTipWrapper(_ref6) {
  var appliedFilters = _ref6.appliedFilters,
      onButtonMouseDown = _ref6.onButtonMouseDown,
      togglePopOver = _ref6.togglePopOver,
      tooltipGroups = _ref6.tooltipGroups,
      className = _ref6.className,
      ariaLabel = _ref6.ariaLabel,
      dataTestId = _ref6.dataTestId,
      buttonRef = _ref6.buttonRef;
  var appliedFiltersCount = getAppliedFiltersCount(appliedFilters, tooltipGroups);
  return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: function text() {
      return /*#__PURE__*/_react["default"].createElement(RenderToolTip, {
        appliedFilters: appliedFilters,
        tooltipGroups: tooltipGroups
      });
    },
    placement: "bottom",
    showToolTip: !togglePopOver && !!appliedFiltersCount,
    className: "oui-filter-tooltip"
  }, /*#__PURE__*/_react["default"].createElement(ButtonWrapper, {
    appliedFilters: appliedFilters,
    onButtonMouseDown: onButtonMouseDown,
    tooltipGroups: tooltipGroups,
    className: className,
    ariaLabel: ariaLabel,
    dataTestId: dataTestId,
    buttonRef: buttonRef
  }));
};

exports.ToolTipWrapper = ToolTipWrapper;

var createGroupedTooltip = function createGroupedTooltip(appliedFilters, tooltipGroups) {
  var _context4;

  var tooltipRows = (0, _map2["default"])(appliedFilters, function (_ref7, key) {
    var fieldName = _ref7.fieldName,
        title = _ref7.title,
        value = _ref7.value,
        _ref7$valueRenderer = _ref7.valueRenderer,
        valueRenderer = _ref7$valueRenderer === void 0 ? null : _ref7$valueRenderer;

    if (!isFieldInTooltipGroups(tooltipGroups, fieldName) && !(0, _utils.isEmpty)(value) && title) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-filter",
        key: key
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "oui-filter-title",
        key: title
      }, title), renderFilter(value, valueRenderer));
    }
  });
  var groupedFields = (0, _filter["default"])(_context4 = (0, _map["default"])(tooltipGroups).call(tooltipGroups, function (group) {
    if ((0, _utils.isFunction)(group.groupRenderer)) {
      var fields = createGroupFieldValuesObject(group.fields, appliedFilters);
      var fieldValues = (0, _values["default"])(fields);
      var notEmptyFields = (0, _filter["default"])(fieldValues).call(fieldValues, function (f) {
        return f.value;
      });

      if (notEmptyFields.length > 0) {
        var groupRenderValue = group.groupRenderer(fields);
        return groupRenderValue ? /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-filter",
          key: group.groupName
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-filter-title",
          key: group.groupName
        }, group.groupName), /*#__PURE__*/_react["default"].createElement("div", {
          className: "oui-filter-value"
        }, groupRenderValue)) : "";
      }

      return "";
    }
  })).call(_context4, Boolean);
  return (0, _concat["default"])(tooltipRows).call(tooltipRows, groupedFields);
};

exports.createGroupedTooltip = createGroupedTooltip;

var createGroupFieldValuesObject = function createGroupFieldValuesObject(fields, appliedFilters) {
  var fieldValues = {};
  (0, _forEach["default"])(fields).call(fields, function (fieldName) {
    fieldValues[fieldName] = getValueOfAppliedField(fieldName, appliedFilters);
  });
  return fieldValues;
};

exports.createGroupFieldValuesObject = createGroupFieldValuesObject;

var getValueOfAppliedField = function getValueOfAppliedField(fieldName, appliedFilters) {
  var value = null;
  var remainingCount = 0;

  var valueRenderer = function valueRenderer(v) {
    return v;
  };

  var _iterator = _createForOfIteratorHelper(appliedFilters),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var filter = _step.value;

      if (filter.fieldName === fieldName) {
        value = filter.value;

        if ((0, _utils.isFunction)(filter.valueRenderer)) {
          valueRenderer = filter.valueRenderer;
        }

        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if ((0, _isArray2["default"])(value) && value && (0, _utils.isObject)(value[0])) {
    remainingCount = value.length - showMaxFilterValues;
    value = (0, _map2["default"])((0, _take["default"])(value, showMaxFilterValues), function (valueObject) {
      return valueObject;
    });
  } else if ((0, _isArray2["default"])(value) && value && (0, _isString["default"])(value[0])) {
    remainingCount = value.length - showMaxFilterValues;
    value = (0, _map2["default"])((0, _take["default"])(value, showMaxFilterValues), function (valueString) {
      return valueString;
    });
  } else if ((0, _utils.isObject)(value) && value.label) {
    value = value.label;
  }

  return {
    value: valueRenderer(value),
    remainingCount: Math.max(remainingCount, 0)
  };
};

exports.getValueOfAppliedField = getValueOfAppliedField;

var isFieldInTooltipGroups = function isFieldInTooltipGroups(tooltipGroups, fieldName) {
  if (tooltipGroups && fieldName) {
    var _iterator2 = _createForOfIteratorHelper(tooltipGroups),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _context5;

        var group = _step2.value;

        if (group.fields && (0, _includes["default"])(_context5 = group.fields).call(_context5, fieldName)) {
          return group;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return false;
};

exports.isFieldInTooltipGroups = isFieldInTooltipGroups;

var makeFieldNameToGroupMap = function makeFieldNameToGroupMap(tooltipGroups) {
  var map = {};

  if (tooltipGroups && (0, _isArray["default"])(tooltipGroups)) {
    (0, _forEach["default"])(tooltipGroups).call(tooltipGroups, function (group) {
      if (group.fields && (0, _isArray["default"])(group.fields)) {
        var _context6;

        (0, _forEach["default"])(_context6 = group.fields).call(_context6, function (field) {
          map[field] = group.groupName;
        });
      }
    });
  }

  return map;
};

exports.makeFieldNameToGroupMap = makeFieldNameToGroupMap;

var getTooltipGroupAppliedCount = function getTooltipGroupAppliedCount(appliedFilters, tooltipGroups) {
  var fieldToGroup = makeFieldNameToGroupMap(tooltipGroups);
  var consumedGroups = [];
  var count = 0;
  (0, _forEach["default"])(appliedFilters).call(appliedFilters, function (_ref8) {
    var value = _ref8.value,
        fieldName = _ref8.fieldName;

    if (!(0, _utils.isEmpty)(value)) {
      if (isFieldInTooltipGroups(tooltipGroups, fieldName)) {
        if (!(0, _includes["default"])(consumedGroups).call(consumedGroups, fieldToGroup[fieldName])) {
          count += 1;
          consumedGroups.push(fieldToGroup[fieldName]);
        }
      } else {
        count += 1;
      }
    }
  });
  return count;
};

exports.getTooltipGroupAppliedCount = getTooltipGroupAppliedCount;